var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowDeviceViewIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_867_4539)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "#152D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.179 14.999L25.8486 20.6882C25.9638 20.8033 26.0465 20.9253 26.0967 21.054C26.1468 21.1827 26.1719 21.32 26.1719 21.4659C26.1719 21.6118 26.1468 21.7492 26.0967 21.8779C26.0465 22.0066 25.9638 22.1285 25.8486 22.2437L20.1595 27.9133C19.9439 28.1288 19.6815 28.2365 19.372 28.2365C19.0624 28.2365 18.7999 28.1288 18.5844 27.9133C18.3689 27.6979 18.2644 27.4386 18.271 27.1356C18.2775 26.8325 18.3885 26.5733 18.604 26.3578L23.4763 21.4659L18.5844 16.5936C18.3689 16.3781 18.2612 16.1124 18.2612 15.7963C18.2612 15.4802 18.3689 15.2145 18.5844 14.999C18.7999 14.7835 19.0657 14.6758 19.3817 14.6758C19.6978 14.6758 19.9636 14.7835 20.179 14.999Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.516167,
    y: 0.516167,
    width: 41.9677,
    height: 41.9677,
    rx: 20.9838,
    stroke: "white",
    strokeWidth: 1.03233
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_867_4539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowDeviceViewIconNew);
export default __webpack_public_path__ + "static/media/showDeviceViewIconNew.d742c386.svg";
export { ForwardRef as ReactComponent };